import React from 'react'
import ReactDOM from 'react-dom'
import { useSwipeable, Swipeable } from 'react-swipeable'

import Idle from './containers/Idle'
import IdleVertical from './containers/IdleVertical'

import AuthPage from './containers/AuthPage'

import ElementsField from './containers/ElementsField'
import ElementsFieldVertical from './containers/ElementsFieldVertical'

import ElementPage from './containers/ElementPage'
import ElementPageVertical from './containers/ElementPageVertical'

import ElementAdditionalPage from './containers/ElementAdditionalPage'
import ElementAdditionalPageVertical from './containers/ElementAdditionalPageVertical'

import Menu from './containers/Menu'
import MenuVertical from './containers/MenuVertical'

import AddMenu from './containers/AddMenu'
import AddMenuVertical from './containers/AddMenuVertical'

import ModalWindow from './containers/ModalWindow'

import {ReactComponent as IconMenu} from './svgs/menu.svg';

import api from './api/api'
import hash from './lib/pass-hash/pass-hash'
import localization from './lib/localization/localization'
import ifvisible from '../node_modules/ifvisible.js'
import vhCheck from 'vh-check'

import ProgressLine from "./components/ProgressBar";

const ui_version = "1.2.0"
const logging = false
const SendTimeout = 200
const ValueDelta = 10
const ElementHW = 200
const DefaultTemp = '24'
const CookieUserName = 'login'
const CookieUserPass = 'passhash'
const CookieUserToken = 'token'
const CookieUserTokenExp = 'tokenexpiration'
const CookieUiMode = 'ui_mode'
const CookieUiLanguage = 'ui_lang'
const CookieLatt = 'location_latt'
const CookieLong = 'location_long'
const isMobile = /Mobile|webOS|BlackBerry|IEMobile|MeeGo|mini|Fennec|Windows Phone|Android|iP(ad|od|hone)/i.test(navigator.userAgent);
const BackgroundBlack = '/images/black.jpg';
const BackgroundWhite = '/images/white.jpg';
const BackgroundBrown = '/images/brown.jpg';
const BackgroundGray = '/images/gray.jpg';
const BackgroundOverlay = '/images/overlay.png';
const def_latt = 25.998
const def_long = -97.156
const TOKEN_EXP_DELTA = 15*24*60*60*1000 // 15 days [ms]
const REFRESH_TOKEN_PERIOD = 60*1000 // 1 min [ms]

let ui_language_default = 'English'
let global_element_id
let css_var = document.querySelector('body')
let frst_init = true
let page_data = ''
let sys_time = Date.now()
let load_text = '...'
let menu 
let connection = false
let auth = false
let upd_config = false
let nnew_params
let prew_state = 'Loading'
let cur_time = '00:00'
let ui_mode_default = 0
let HvParams = vhCheck()
let timer
let touchduration = 700;
let is_new_software = false
let idle_timeout = 150
let weather_updater = false
let dest_params = []
let pos_x = 0
let pos_y = 0
let window_h = 0
let window_w = 0
let columns = 6
let resize_start = false
let chart_data


function App() {

  const [screen_type, setScreenType] = React.useState('')
  
  const [ui_mode, setUiMode] = React.useState()

  const [ui_state, setUiState] = React.useState('Loading')

  const [ui_language, setUiLanguage] = React.useState('English')

  const [percent, setPercent] = React.useState('0')

  const [modal_msg, setModalMsg] = React.useState('')

  const [config, setConfig] = React.useState({
    ui_rooms: [],
    ui_categories: [],
    ui_items: []
  })
  
  const [elfield, setElfield] = React.useState( {field_type: 'room', field_id: 1, ui_cfg: config} )
  
  const [params, setParams] = React.useState([])

  const [users, setUsers] = React.useState([])

  const [latt_long, setLattLong] = React.useState([def_latt, def_long])

  const [weath_data, setWeathData] = React.useState('')

  ifvisible.setIdleDuration(idle_timeout);
  
  if(config) menu = [config.ui_rooms, config.ui_categories]
  else menu = [null, null]

  printLog('Re-render')
  printLog('params',params)
  printLog('dest_params',dest_params)
  printLog('config',config)
  printLog('elfield',elfield)
  printLog('ui_state',ui_state)
  printLog('connection',connection)
  printLog('auth',auth)
  printLog('screen_type',screen_type)

  // logging
  function printLog(msg, param){
    if ((logging) && (param != null)) console.log(msg, param)
    else if (logging) console.log(msg)
  }

  initAll()
  api.initRequests(updParam, updConfigVersion, updUpdateSoftwareFinish, updNewSoftware, updServerWorkState, updUpdateSoftwareProgress)

  // Window resize timer
  setInterval(() => {
    windowUpdate()
  }, 1000);

  window.addEventListener("resize", ()=>{
    windowUpdate()
  } );

  function windowUpdate(){
      HvParams = vhCheck()
      let local_w_w = window.innerWidth
      let local_w_h = HvParams.windowHeight
        /*printLog('window Width Local',local_w_w)
        printLog('window Width ',window_w)
        printLog('window Height Local',local_w_h)
        printLog('window Height ',window_h)
        printLog('window screen_type ',screen_type)*/
      let new_window = false
      if ((local_w_w != window_w) || (local_w_h != window_h)){
        printLog('1')
        if (local_w_h != null){
          printLog('2')
          if (local_w_h != window_h) {
            printLog('3')
            window_h = local_w_h
            css_var.style.setProperty('--viewheight', local_w_h + 'px')
            new_window = true
          }
          if (local_w_w != window_w) {
            printLog('4')
            window_w = local_w_w
            new_window = true
          }
          if (new_window) {
            printLog('5')
            let local_columns = parseInt(local_w_w/ElementHW)
            // Horizontal mode
            if (local_w_w >= local_w_h) {
              printLog('6')
              if (local_columns<6) local_columns = 6
              if (screen_type != 'horizontal') setScreenType('horizontal')
            }
            // Vertical mode
            else if (local_w_w < local_w_h) {
              printLog('7')
              if (local_columns<3) local_columns = 3
              if (screen_type != 'vertical') setScreenType('vertical')
            }
            if (local_columns != columns){
              printLog('8')
              columns = local_columns
              css_var.style.setProperty('--columns', local_columns)
            }
          }
        }
      }
  }

  // Lock screen
  ifvisible.on("idle", function(){
    if (ui_state !== 'Idle'){
      if (ui_state !== prew_state) prew_state = ui_state;
      setUiState('Idle');
    }
  });
  
  ifvisible.on("wakeup", function(){
    setUiState(prew_state);
  });

  // Token update
  async function refreshToken() {
    if ((connection)&&(auth)){
      let cookie_user = localStorage.getItem(CookieUserName)
      let cookie_token = localStorage.getItem(CookieUserToken)
      let cookie_token_exp = localStorage.getItem(CookieUserTokenExp)
      if (cookie_user && cookie_token && (cookie_token_exp <= sys_time + TOKEN_EXP_DELTA)) {
        let refresh_auth_token_answer = await api.sendRefreshToken();
        if (refresh_auth_token_answer){
          if(refresh_auth_token_answer.result){
            if (refresh_auth_token_answer.auth_token_expiration && refresh_auth_token_answer.auth_token) {
              localStorage.setItem(CookieUserTokenExp, refresh_auth_token_answer.auth_token_expiration)
              localStorage.setItem(CookieUserToken, refresh_auth_token_answer.auth_token)
            }
          }
        }
      }
    }
  }

  // Init API and first screen type
  function initAll(){
    if (frst_init) {
      frst_init = false
      load_text = localization.localize(ui_language).loading
      printLog('Start INIT')
      
      if(localStorage.getItem(CookieUiMode)) {
        ui_mode_default = parseInt(localStorage.getItem(CookieUiMode))
      }
      setUiMode(ui_mode_default)
      UiModeInit(ui_mode_default)
      localStorage.setItem(CookieUiMode, ui_mode_default)

      if(localStorage.getItem(CookieUiLanguage)) {
        ui_language_default = localStorage.getItem(CookieUiLanguage)
      }
      setUiLanguage(ui_language_default)
      localStorage.setItem(CookieUiLanguage, ui_language_default)

      windowUpdate()
      
      api.initialize(socketOnOpen, socketOnClose)
      printLog('Stop INIT')

      if((!localStorage.getItem(CookieLatt)) || (!localStorage.getItem(CookieLong))) {
        navigator.geolocation.getCurrentPosition(function(position) {
          let new_latt = position.coords.latitude.toFixed(3)
          let new_long = position.coords.longitude.toFixed(3)
          printLog('Storage LOCATION N1', new_latt)
          printLog('Storage LOCATION N2', new_long)

          if ((new_latt) && (new_long)) {
            localStorage.setItem(CookieLatt, new_latt)
            localStorage.setItem(CookieLong, new_long)
            setLattLong([new_latt, new_long])
          }
        });
      }
      else setLattLong([localStorage.getItem(CookieLatt), localStorage.getItem(CookieLong)])

      refreshToken();
      setInterval(() => {
        refreshToken();
      }, REFRESH_TOKEN_PERIOD);
    }
  }

  // Open socket connection
  async function socketOnOpen() {
    load_text = localization.localize(ui_language).connected
    printLog('Socket open',ui_state)
    connection = true
    setUiState('Start')
  }

  // New software check
  async function newSoftwareCheck(){
    printLog('sendGetNewSoftware')
    printLog('is_new_software',is_new_software)
    let new_soft = await api.sendGetNewSoftware(1);
    if ((new_soft)&&(new_soft.new_software)) is_new_software = true
    else is_new_software = false
  }

  // New software on FTP check
  async function newFtpSoftwareCheck(){
    printLog('sendCmdCheckNewSoftware')
    let new_soft = await api.sendCmdCheckNewSoftware();
  }

  // Close socket connection
  function socketOnClose() {
    load_text = localization.localize(ui_language).await_connection
    printLog('Socket close')
    connection = false
    auth = false
    printLog('Socket close2', ui_state) 
    if (ui_state !== 'Loading') setUiState('Loading')    
  }
  
  // Update param from API
  function newParam (data){
    printLog('params', params)
    nnew_params = []
    printLog('nnew_params1',nnew_params)
    printLog('params', params)
    for (let i = 0; i < params.length; i++) {
      if (parseInt(params[i].param_id) === data.param_id) {
        printLog('data.param_id',data.param_id)
        nnew_params[i] = {param_id: parseInt(data.param_id), param_value: data.param_value}
        if ((data.param_value != 0) && (data.param_value != null) && (data.param_value != NaN)) {
          dest_params[i] = nnew_params[i]
          printLog('dest_1_params['+(i)+']', nnew_params[i])
        }
        else dest_params[i] = {"param_id": nnew_params[i].param_id, "param_value": null}
      }
      else nnew_params[i] = params[i]
    }
    printLog('nnew_params2', nnew_params)
    if (nnew_params !== params) {
      printLog('nnew_params !== params', nnew_params, params)
      setParams(nnew_params)
    }
  }
  
  function updParam(data, options){
    load_text = localization.localize(ui_language).update_parameters 
    printLog('updParam', data)
    if (data){
      if (data.error_code) printLog(data)
      newParam(data)      
      return {result: true, req_id:data.req_id}
    }
    else {
      load_text = localization.localize(ui_language).update_parameters_fault
      pushWindow ('(＃￣0￣)  ' + localization.localize(ui_language).update_parameters_fault)
      return {result: false, req_id:data.req_id}
    }
  }
  
  async function updConfigVersion(data, options){
    load_text = localization.localize(ui_language).update_configuration
    printLog('updConfigVersion', data)
    if (data !== null){
      if (data.error_code) printLog(data)
      setTimeout(async () => {
        await getConfig()
      }, 1000);
      return {result: true, req_id:data.req_id}
    }
    else {
      load_text = localization.localize(ui_language).update_configuration_fault
      pushWindow ('(＃￣0￣)  ' + localization.localize(ui_language).update_configuration_fault)
      return {result: false, req_id:data.req_id}
    }
  }

  // Receive Software Upd Finished msg from server
  async function updUpdateSoftwareFinish(data, options){
    load_text = localization.localize(ui_language).software_upd_finish
    idle_timeout = 150;
    printLog('updUpdateSoftwareFinish', data)
    if (data !== null){
      if (data.error_code) printLog(data)
      let frontend_updated = false
      if (data.updated_software) {
        for (let i = 0; i < data.updated_software.length; i++) {
          if (data.updated_software[i] == 'ui') frontend_updated = true
        }
      }
      if (frontend_updated) {
        setTimeout(() => {
          document.location.reload()
        }, 1000)
      }
      else if (ui_state == 'SoftwareUpdate') {
        setTimeout(() => {
          setUiState(prew_state)
        }, 1000)
      }
      return {result: true, req_id:data.req_id}
    }
    else {
      return {result: false, req_id:data.req_id}
    }
  }

  // Push window
  function pushWindow(msg){
    css_var.style.setProperty('--filter', 'blur(5px)')
    setModalMsg(msg)
  }

  // Close Push window
  function closeModal(){
    css_var.style.setProperty('--filter', '')
    setModalMsg('')
  }

  // Receive Software progress from server
  async function updUpdateSoftwareProgress(data, options){
    printLog('Receive Software progress from server' , data)
    printLog('ui_state' , ui_state)
    if (data) {
      if (data.error_code) printLog(data)
      if (ui_state == 'SoftwareUpdate'){
        setPercent(data.progress)
        load_text = localization.localize(ui_language).software_upd + ' ' + data.progress + '%'
        ReactDOM.render(load_text, document.getElementById('load_text'))
      }
      return {result: true, req_id:data.req_id}
    }
    else {
      return {result: false, req_id:data.req_id}
    }
  }
  
  // Receive New Software available msg from server
  async function updNewSoftware(data, options){
    if (data){
      if (data.error_code) printLog(data)
      is_new_software = true
      setTimeout(() => {
        printLog('ALERT')
        pushWindow('＼(￣▽￣)／  ' + localization.localize(ui_language).software_available)
      }, 1000)
      return {result: true, req_id:data.req_id}
    }
    else return {result: false, req_id:data.req_id}
  }

  // Start update
  async function clickUpdateButton(){
    setPercent('0')
    prew_state = ui_state
    idle_timeout = 10000
    load_text = localization.localize(ui_language).software_upd
    printLog("clickUpdateButton")
    let msg = await api.sendCmdUpdateSoftware(1)
    printLog('msg', msg)
    printLog('prew_state', prew_state)
    if (msg) {
      if (msg.result) setUiState('SoftwareUpdate')
    }
    else pushWindow('╮( ˘ ､ ˘ )╭  ' + localization.localize(ui_language).already_updated)
  }
  

  // Server send new work state
  async function updServerWorkState(data, options){
    if (data !== null){
      if (data.error_code) printLog(data)
      prew_state = ui_state;
      if(data.work_state == 2) {
        load_text = localization.localize(ui_language).software_upd
        setUiState('SoftwareUpdate')
      }
      else {
        setTimeout(async () => {
          if (ui_state == 'SoftwareUpdate') setUiState(prew_state)
        }, 500);
      }
      return {result: true, req_id:data.req_id}
    }
    return {result: false, req_id:data.req_id}
  }
  
  // Back to normal state from Element page or Menu
  function toNormalState(){
    printLog('Back to normal')
    if (ui_state !== 'Normal') setUiState('Normal')
  }

  // Get Param Chart Data
  async function apiGetChartData(param_id, duration){
    let chart_data = null
    let msg = null
    msg = await api.sendGetParamHistory(param_id, duration)
    if (msg) {
        if (msg.result) chart_data = apiDataToXY(msg.param_history)
    }
    return chart_data
  }

  function apiDataToXY(array){
    let new_array = []
    for (let i = 0; i < array.length; i++) {
        let y_data = parseFloat(array[i].param_value)
        if (isNaN(y_data)){
          switch (array[i].param_value) {
            case "false":
            case "ok":
              y_data = 0;
              break;
            case "true":
            case "warning":
              y_data = 1;
              break; 
              case "error":
              y_data = 2;
              break;             
            default:
              break;
          }

        }
        else if(y_data > 10000) y_data = 0
        new_array[i] = {x: array[i].time, y: y_data}
    }
    return new_array;
  }

  async function xAlignDataUpdater(array1, array2, array3){
    let array_x = []
    let array1_x = []
    let array2_x = []
    let array3_x = []

    for (let i = 0; i < array1.length; i++) {array1_x[i] = array1[i].x}
    for (let i = 0; i < array2.length; i++) {array2_x[i] = array2[i].x}
    for (let i = 0; i < array3.length; i++) {array3_x[i] = array3[i].x}

    array_x = (array1_x).concat(array2_x, array3_x)

    for (var q=1, i=1; q<array_x.length; ++q) {
        if (array_x[q] !== array_x[q-1]) {
            array_x[i++] = array_x[q];
        }
    }
    array_x.length = i;
    array_x = array_x.sort()

    let cnt1 = 0
    let cnt2 = 0
    let cnt3 = 0
    let array1_out = []
    let array2_out = []
    let array3_out = []

    for (let i = 0; i < array_x.length; i++) {
        if (array_x[i] < array1[cnt1].x) {
            if (i>0) array1_out[i] = {x: array_x[i], y: array1_out[i-1].y}
            else array1_out[i] = {x: array_x[i], y: 0}
        }
        else if (array_x[i] = array1[cnt1].x) { 
            array1_out[i] = {x: array_x[i], y: array1[cnt1].y}
            if (cnt1+1 < array1.length) cnt1++
        }

        if (array_x[i] < array2[cnt2].x) {
            if (i>0) array2_out[i] = {x: array_x[i], y: array2_out[i-1].y}
            else array2_out[i] = {x: array_x[i], y: 0}
        }
        else if (array_x[i] = array2[cnt2].x) { 
            array2_out[i] = {x: array_x[i], y: array2[cnt2].y}
            if (cnt2+1 < array2.length) cnt2++
        }

        if (array_x[i] < array3[cnt3].x) {
            if (i>0) array3_out[i] = {x: array_x[i], y: array3_out[i-1].y}
            else array3_out[i] = {x: array_x[i], y: 0}
        }
        else if (array_x[i] = array3[cnt3].x) { 
            array3_out[i] = {x: array_x[i], y: array3[cnt3].y}
            if (cnt3+1 < array3.length) cnt3++
        }

    }
    return {a1:array1_out, a2:array2_out, a3:array3_out}
}

async function rgbHueDataUpdater(ah, as, av) {
    
    let hsv = await xAlignDataUpdater(ah, as, av)

    printLog('hsv',hsv)

    let arr_r = [{x: null, y: null}]
    let arr_g = [{x: null, y: null}]
    let arr_b = [{x: null, y: null}]

    for (let ii = 0; ii < (hsv.a1).length; ii++) {
        var h = hsv.a1[ii].y
        var s = hsv.a2[ii].y
        var v = hsv.a3[ii].y

        var r, g, b;
        var i;
        var f, p, q, t;

        h = Math.max(0, Math.min(100, h));
        s = Math.max(0, Math.min(100, s));
        v = Math.max(0, Math.min(100, v));
        if (h === 100) h = 0;
        else h = h*360/100; //0-100 => 0-360
        v /= 100;
        if(s == 0) {
            r = g = b = v;
        }
        else {
        s /= 100;
        h /= 60;
        i = Math.floor(h);
        f = h - i;
        p = v * (1 - s);
        q = v * (1 - s * f);
        t = v * (1 - s * (1 - f));
        switch(i) {
            case 0: r = v; g = t; b = p; break;
            case 1: r = q; g = v; b = p; break;
            case 2: r = p; g = v; b = t; break;
            case 3: r = p; g = q; b = v; break;
            case 4: r = t; g = p; b = v; break;
            default: r = v; g = p; b = q; break;
        }
        }
        arr_r[ii] = {x: hsv.a1[ii].x, y:Math.round(r * 100)}
        arr_g[ii] = {x: hsv.a1[ii].x, y:Math.round(g * 100)}
        arr_b[ii] = {x: hsv.a1[ii].x, y:Math.round(b * 100)}
    }
    return { r:arr_r, g:arr_g, b:arr_b };
}


  // Chart state from Element page
  async function toChartState(elem_id, duration){
    printLog('To chart', elem_id)
    let element_params
    let element_type
    let element_add_data
    let params_history = false
    config.ui_items.map(item => {
      if (item.ui_item_id === elem_id) {
          element_params = item.params
          element_type = item.ui_item_type
          element_add_data = item.add_data
      }
    }
    )
    chart_data = null
    switch (element_type) {
      case 'switch':
          let switch_param_id    
          element_params.map(param => {
              if (param.param_sub_id == 'state') {
                  if (param.is_history_save) {
                    params_history = true
                    switch_param_id = param.param_id
                  }
              }
          }
          )
          if (switch_param_id) {
            printLog('params_history', params_history, switch_param_id)
            if (params_history) chart_data = {type: "switch", state: await apiGetChartData(switch_param_id, duration)}
            printLog('chart_data', chart_data)
          }
          break;

      case 'rgb':
      case 'rgbw':
          let rgb_param_id = []
          element_params.map(param => {
              if (param.param_sub_id == "bright") {
                if (param.is_history_save) {
                  params_history = true
                  rgb_param_id[2] = param.param_id
                }
              }
              else if (param.param_sub_id == "hue") {
                if (param.is_history_save) {
                  params_history = true
                  rgb_param_id[0] = param.param_id
                }
              }
              else if (param.param_sub_id == "saturation") {
                if (param.is_history_save) {
                  params_history = true
                  rgb_param_id[1] = param.param_id
                }
              }
          }
          )
          if (rgb_param_id.length = 3) {
            let hue = await apiGetChartData(rgb_param_id[0], duration)
            let saturation = await apiGetChartData(rgb_param_id[1], duration)
            let bright = await apiGetChartData(rgb_param_id[2], duration)
            printLog('hue', hue)
            printLog('saturation', saturation)
            printLog('bright', bright)

            if(Array.isArray(hue) && Array.isArray(saturation) && Array.isArray(bright)) {
              let rgb_components = await rgbHueDataUpdater(hue, saturation, bright)
              chart_data = {type: "rgb", r: rgb_components.r, g: rgb_components.g, b: rgb_components.b, bright: bright}
            }
          }

          printLog('chart_data', chart_data)
          break;

    case 'warm_cold':
          let wc_param_id = []
          element_params.map(param => {
              if (param.param_sub_id == "bright") {
                if (param.is_history_save) {
                  params_history = true
                  wc_param_id[1] = param.param_id
                }
              }
              else if (param.param_sub_id == "hue") {
                if (param.is_history_save) {
                  params_history = true
                  wc_param_id[0] = param.param_id
                }
              }
          }
          )

          if (wc_param_id.length = 2) {
            chart_data = {type: "wc", hue: await apiGetChartData(wc_param_id[0], duration), bright: await apiGetChartData(wc_param_id[1], duration)}
            printLog('chart_data', chart_data)
          }
          break;

    case 'dimmer':
        let dimmer_param_id    
        element_params.map(param => {
            if (param.param_sub_id == "bright") {
                if (param.is_history_save) {
                  params_history = true
                  dimmer_param_id = param.param_id
                }
            }
        }
        )

        if (dimmer_param_id) {
          printLog('params_history', params_history, dimmer_param_id)
          if (params_history) chart_data = {type: "dimmer", bright: await apiGetChartData(dimmer_param_id, duration)}
          printLog('chart_data', chart_data)
        }
      break;

    case 'status':
        let status_param_id 
        element_params.map(param => {
            if (param.param_sub_id == "text") {
                if (param.is_history_save) {
                  params_history = true
                  status_param_id = param.param_id
                }
            }
        }
        )
        if (status_param_id) {
          printLog('status_param_id', status_param_id)
          if (params_history) chart_data = {type: "status", text: await apiGetChartData(status_param_id, duration), add_data: element_add_data}
          printLog('chart_data', chart_data)
        }
      break;


    case 'thermostat':
        let thermostat_param_id = []
        element_params.map(param => {
            if (param.param_sub_id == "curr_temp") {
                if (param.is_history_save) {
                  params_history = true
                  thermostat_param_id[0] = param.param_id
                }
            }
            else if (param.param_sub_id == "comf_temp") {
              if (param.is_history_save) {
                params_history = true
                thermostat_param_id[1] = param.param_id
              }
            }
            else if (param.param_sub_id == "mode") {
              if (param.is_history_save) {
                params_history = true
                thermostat_param_id[2] = param.param_id
              }
            }
        }
        )

        if (thermostat_param_id.length = 3) {
          if (params_history) chart_data = {type: "thermostat", curr_temp: await apiGetChartData(thermostat_param_id[0], duration), comf_temp: await apiGetChartData(thermostat_param_id[1], duration), mode: await apiGetChartData(thermostat_param_id[2], duration)}
          printLog('chart_data', chart_data) 
        }
      break;

    case 'curtains':
        let curtains_param_id = []   
        element_params.map(param => {
            if (param.param_sub_id == "curr_pos") {
                if (param.is_history_save) {
                  params_history = true
                  curtains_param_id[0] = param.param_id
                }
            }
            else if (param.param_sub_id == "target_pos") {
              if (param.is_history_save) {
                params_history = true
                curtains_param_id[1] = param.param_id
              }
          }
        }
        )

        if (curtains_param_id.length = 2) {
          printLog('params_history', params_history, curtains_param_id)
          if (params_history) chart_data = {type: "curtains", curr_pos: await apiGetChartData(curtains_param_id[0], duration), target_pos: await apiGetChartData(curtains_param_id[1], duration)}
          printLog('chart_data', chart_data)
        }
      break;
    }

    if (ui_state !== 'ElementAdditional') setUiState('ElementAdditional')
  }

  // Start authorization
  async function authStart(auth_data){
    load_text = localization.localize(ui_language).authorization
    prew_state = ui_state;
    if ((ui_state !== 'Loading')&&(ui_state !== 'Start')) setUiState('Loading')
    let istoken = auth_data.istoken
    let auth_answer = null;
    if (istoken) {
      let token = auth_data.token
      if (token){
        if (!auth_data.new_token) auth_answer = await api.sendAuthParam(auth_data.login, null, token, false);
        else auth_answer = await api.sendAuthParam(auth_data.login, null, token, true);
      }
      else {
        auth = false
        setUiState('Auth')
        pushWindow('(￣ヘ￣)  ' + localization.localize(ui_language).authorization_fault)
      }
    }
    else {
      let pass_hash = auth_data.password
      if (pass_hash){
        if (!auth_data.new_token) auth_answer = await api.sendAuthParam(auth_data.login, pass_hash, null, false);
        else auth_answer = await api.sendAuthParam(auth_data.login, pass_hash, null, true);
      }
      else {
        auth = false
        setUiState('Auth')
        pushWindow('(￣ヘ￣)  ' + localization.localize(ui_language).authorization_fault)
      }
    }
    if (auth_answer === null) {
      auth = false
      setUiState(prew_state) // 'Auth'
    }
    else {
      if (auth_answer.result) {
        auth = true
        if (auth_data.new_token) localStorage.setItem(CookieUserTokenExp, auth_answer.auth_token_expiration)
        if (auth_answer.auth_token) localStorage.setItem(CookieUserToken, auth_answer.auth_token)
        localStorage.setItem(CookieUserName, auth_data.login)
        if (auth_data.password) localStorage.setItem(CookieUserPass, auth_data.password)
        let server_state = await api.sendGetServerWorkState()
        printLog('server_state', server_state)
        if ((server_state.result)&&(server_state.work_state == 2)) {
          load_text = localization.localize(ui_language).software_upd
          setUiState('SoftwareUpdate')
        }
        else {
          if((localStorage.getItem(CookieLatt)) && (localStorage.getItem(CookieLong))){
            weatherUpdate(localStorage.getItem(CookieLatt), localStorage.getItem(CookieLong))
          }
          if (!is_new_software) newSoftwareCheck()
          getConfig()
        }
      }
      else {
        auth = false
        load_text = localization.localize(ui_language).authorization_fault
        if (auth_answer.error_message) pushWindow('(￣ヘ￣)  ' + localization.localize(ui_language).authorization_fault, auth_answer.error_message)
        localStorage.removeItem(CookieUserName)
        localStorage.removeItem(CookieUserPass)
        localStorage.removeItem(CookieUserToken)
        localStorage.removeItem(CookieUserTokenExp)
        setUiState('Auth')
      }
    }
  }

  // update weather data
  async function weatherUpdate(latt_local, long_local){
    localStorage.setItem(CookieLatt, latt_local)
    localStorage.setItem(CookieLong, long_local)
    let weath_pre_data = await fetch('http://api.openweathermap.org/data/2.5/weather?lat='+latt_local+'&lon='+long_local+'&appid=ceccc2f273d8764b68b359e0f0b9a947&units=metric')
    printLog('WEATHER1', weath_pre_data)
    if ((weath_pre_data)&&(weath_pre_data.ok)) {
        weath_pre_data = await weath_pre_data.json()
        let weath_icon = weath_pre_data.weather[0].main
        printLog('weath_icon', weath_icon) 
        let weath_temp = weath_pre_data.main.temp
        let weath_hum = weath_pre_data.main.humidity
        switch (weath_icon) {
          case 'Rain':
            weath_icon = 'lr'
            css_var.style.setProperty('--weather_color', '#00000034')
            break;

          case 'Clouds':
            weath_icon = 'hc'
            css_var.style.setProperty('--weather_color', '#ffffff26')
            break;

          case 'Clear':
            weath_icon = 'c'
            css_var.style.setProperty('--weather_color', '#f7ff7828')
            break;

          case 'Snow':
            weath_icon = 'sn'
            css_var.style.setProperty('--weather_color', '#cdeeeb25')
            break;

          case 'Extreme':
            
            break;

          case 'Drizzle':
            weath_icon = 'hr'
            css_var.style.setProperty('--weather_color', '#e6afea30')
            break;
        
          case 'Mist':
          case 'Smoke':
          case 'Haze':
          case 'Dust':
          case 'Fog':
          case 'Sand':
          case 'Ash':
          case 'Squall':
          case 'Tornado':
            weath_icon = 'lc'
            css_var.style.setProperty('--weather_color', '#6d5cb330')
            break;

          case 'Thunderstorm':
            weath_icon = 't'
            css_var.style.setProperty('--weather_color', '#1b023347')
            break;

          default:
          weath_icon = 'c'
          break;
        }
        let new_weather = {the_temp: weath_temp, humidity: weath_hum, weather_state_abbr: weath_icon}

        setWeathData(new_weather)

        printLog('TEMP', weath_data.the_temp)   
        printLog('HUM', weath_data.humidity) 
        printLog('STATE', weath_data.weather_state_abbr) 
    }
    if (!weather_updater){
      setInterval(async () => {
        await weatherUpdate(latt_long[0], latt_long[1])
      }, 300000);
    }
    weather_updater = true;
    return;
  }

  // Logout function
  function logOut(){
    auth = false
    localStorage.removeItem(CookieUserName)
    localStorage.removeItem(CookieUserPass)
    setUiState('Auth')
  }

  // Additional menu
  function addMenu(){
    printLog('addMenu')
    setUiState('AddMenu')
  }

  // Update UI Language
  function updLanguage(new_language){
    if (new_language !== ui_language_default){
      ui_language_default = new_language
      localStorage.setItem(CookieUiLanguage, new_language)
      setUiLanguage(new_language)
    }
  }

  // Config request from server
  async function getConfig() {
    upd_config = true
    if ((ui_state !== 'Loading')&&(ui_state !== 'Start')) setUiState('Loading')
    load_text = localization.localize(ui_language).update_configuration
    printLog('Send get config request')
    let new_ui_cfg = await api.sendGetUiConfig()
    printLog('new_ui_cfg',new_ui_cfg)
    if((new_ui_cfg) && (new_ui_cfg.result)){
      printLog('new_ui_cfg.ui_cfg.ui_rooms',new_ui_cfg.ui_cfg.ui_rooms)
      for (let i = 0; i < new_ui_cfg.ui_cfg.ui_rooms.length; i++) {
        if (!new_ui_cfg.ui_cfg.ui_rooms[i].ui_room_name) new_ui_cfg.ui_cfg.ui_rooms[i].ui_room_name = localization.localize(ui_language).not_selected
      }
      for (let i = 0; i < new_ui_cfg.ui_cfg.ui_categories.length; i++) {
        if (!new_ui_cfg.ui_cfg.ui_categories[i].ui_category_name) new_ui_cfg.ui_cfg.ui_categories[i].ui_category_name = localization.localize(ui_language).not_selected
      }
      setConfig(new_ui_cfg.ui_cfg)
      let new_elfield = elfield
      new_elfield.ui_cfg = new_ui_cfg.ui_cfg
      printLog('new_elfield',new_elfield)
      setElfield(new_elfield)
      await getParams(new_ui_cfg.ui_cfg)
    }
    else {
      load_text = localization.localize(ui_language).update_configuration_fault
      setTimeout(async() => {await getConfig()}, 1000);
    }
  }

  // All params request from server
  async function getParams(config) {
    if ((ui_state !== 'Loading')&&(ui_state !== 'Start')) setUiState('Loading')
    load_text = localization.localize(ui_language).update_parameters
    printLog('Send get params')
    let new_params = await api.sendGetAllParams()
    printLog('new_params',new_params)
    if ((new_params)&&(new_params.result)) {
      new_params.params.map(async (new_param) => {
        new_param.param_id = parseInt(new_param.param_id)
        if ((new_param.param_value != 0) && (new_param.param_value != null) && (new_param.param_value != NaN)) { 
          dest_params[new_param.param_id - 1] = new_param
          printLog('dest_params['+(new_param.param_id - 1)+']', new_param)
        }
        else dest_params[new_param.param_id - 1] = {"param_id": new_param.param_id, "param_value" : null}

        for (let i = 0; i < config.ui_items.length; i++) {
          if (config.ui_items[i].ui_item_type === 'thermostat'){
            if ((config.ui_items[i].params[1].param_id == new_param.param_id)&&(!new_param.param_value)){
              new_param.param_value = DefaultTemp
              await api.sendSetParam(new_param.param_id, new_param.param_value)
            }
          }
        }
      })
      upd_config = false
      setParams(new_params.params)
      if (localStorage.getItem(CookieUserName) === 'admin'){
        getUsers();
      }
      else setUiState('Normal')
    }
    else {
      setTimeout(async () => {await getParams(config)}, 1000);
    }
  }

  // All users request from server
  async function getUsers(){
    if ((ui_state !== 'Loading')&&(ui_state !== 'Start')) setUiState('Loading')
    load_text = localization.localize(ui_language).update_users
    printLog('Send get users')
    let new_users = await api.sendGetAllUsers()
    printLog('new_users',new_users)
    if ((new_users)&&(new_users.result)) {
      setUsers(new_users.users)
      setUiState('Normal')
    }
    else {
      setTimeout(async () => {await getUsers()}, 1000);
    }
  }

  // Pointer position updater
  function posUpd(event){
    if (event != null){
      pos_x = event.pageX
      pos_y = event.pageY
    }
  }

  // Click at element event
  async function clickMethod(element_id){
    printLog('element: ', element_id)
    let par_id
    let par_new_value
    config.ui_items.map(item =>{
      if((item.ui_item_type === 'switch')&&(item.ui_item_id === element_id)) item.params.map(param =>{
        if(param.param_sub_id === 'state') {
          par_id = param.param_id
          setParams(
            params.map( state=>{
              if(parseInt(state.param_id) === par_id) {
                if (state.param_value === 'true') state.param_value = 'false'
                else state.param_value = 'true'
                printLog('state.param_value', state.param_value)
                par_new_value = state.param_value
              }
              return state
            })
          )
        }
      })
      else if((item.ui_item_type === 'dimmer')&&(item.ui_item_id === element_id)) item.params.map(param =>{
        if(param.param_sub_id === 'bright') {
          par_id = param.param_id
          setParams(
            params.map( state=>{
              if(parseInt(state.param_id) === par_id) {
                if (parseInt(state.param_value) > 0) state.param_value = '0'
                else {
                  if (((dest_params[par_id-1].param_value) != null)&&((dest_params[par_id-1].param_value) != 0)) state.param_value = dest_params[par_id-1].param_value
                  else state.param_value = '100'
                }
                par_new_value = state.param_value
              }
              return state
            })
          )
        }
      })
      else if((item.ui_item_type === 'rgb')&&(item.ui_item_id === element_id)) item.params.map(param =>{
        if(param.param_sub_id === 'bright') {
          par_id = param.param_id
          let upd_params = params.map( state=>{
              if(parseInt(state.param_id) === par_id) {
                if (parseInt(state.param_value) > 0) state.param_value = '0'
                else {
                  if (((dest_params[par_id-1].param_value) != null)&&((dest_params[par_id-1].param_value) != 0)) state.param_value = dest_params[par_id-1].param_value
                  else state.param_value = '100'
                }
                par_new_value = state.param_value
              }
              return state
            })
            setParams(upd_params)
        }
      })
      else if((item.ui_item_type === 'rgbw')&&(item.ui_item_id === element_id)) item.params.map(param =>{
        if(param.param_sub_id === 'bright') {
          par_id = param.param_id
          let upd_params = params.map( state=>{
              if(parseInt(state.param_id) === par_id) {
                if (parseInt(state.param_value) > 0) state.param_value = '0'
                else {
                  if (((dest_params[par_id-1].param_value) != null)&&((dest_params[par_id-1].param_value) != 0)) state.param_value = dest_params[par_id-1].param_value
                  else
                  state.param_value = '100'
                }
                par_new_value = state.param_value
              }
              return state
            })
            setParams(upd_params)
        }
      })
      else if((item.ui_item_type === 'warm_cold')&&(item.ui_item_id === element_id)) item.params.map(param =>{
        if(param.param_sub_id === 'bright') {
          par_id = param.param_id
          setParams(
            params.map( state=>{
              if(parseInt(state.param_id) === par_id) {
                if (parseInt(state.param_value) > 0) state.param_value = '0'
                else {
                  if (((dest_params[par_id-1].param_value) != null)&&((dest_params[par_id-1].param_value) != 0)) state.param_value = dest_params[par_id-1].param_value
                  else state.param_value = '100'
                }
                par_new_value = state.param_value
              }
              return state
            })
          )
        }
      })
      else if((item.ui_item_type === 'curtains')&&(item.ui_item_id === element_id)) item.params.map(param =>{
        if(param.param_sub_id === 'target_pos') {
          par_id = param.param_id
          setParams(
            params.map( state=>{
              if(parseInt(state.param_id) === par_id) {
                if (parseInt(state.param_value) > 50) state.param_value = '0'
                else state.param_value = '100'
                par_new_value = state.param_value
              }
              return state
            })
          )
        }
      })
    })
    if (par_id){
      printLog('param: ', par_id, '; new_value: ' , par_new_value)
      let answer = await api.sendSetParam(par_id, par_new_value)
      printLog('answer', answer)
    }
  }


  // Open Element page
  function boubleClickMethod(element_id){
    let e = window.event
    printLog('Double e = ', e)
    //let pos_x = parseInt(e.clientX / 1) 
    //let pos_y = parseInt(e.clientY / 1)
    printLog('pos_x = ', pos_x)
    printLog('pos_y = ', pos_y)
    css_var.style.setProperty('--pos_x', pos_x+'px')
    css_var.style.setProperty('--pos_y', pos_y+'px')
    printLog('Double ui id = ', element_id)
    global_element_id = element_id
    setUiState('Element')
  }

  // Update thermostat param temp +
  function clickPlus(element_id){
    printLog('thermo - element: ', element_id)
    let par_id = 0
    let par_new_value = null
    config.ui_items.map(item =>{
      if((item.ui_item_type === 'thermostat')&&(item.ui_item_id === element_id)) {
        let step
        if (JSON.parse(item.add_data).hasOwnProperty('change_step')) {
          step = JSON.parse(item.add_data).change_step
          if (!step) step = 1;
        }
        item.params.map(param =>{
          if(param.param_sub_id === 'comf_temp') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  if(state.param_value){
                    par_new_value = parseFloat((parseFloat(state.param_value) + step).toFixed(1))
                    if(par_new_value>=99) par_new_value = 99;
                    state.param_value = par_new_value.toString()
                  }
                }
                return state
              })
            )
          }
        })
      }
    })
    printLog('Thermostat param: ', par_id, '; new_value: ' , par_new_value)
    if((par_new_value>=0)&&(par_new_value<100)) api.sendSetParam(par_id, par_new_value.toString()) 
  }

  // Update thermostat param temp -
  function clickMinus(element_id){
    printLog('thermo - element: ', element_id)
    let par_id = 0
    let par_new_value = null
    config.ui_items.map(item =>{
      if((item.ui_item_type === 'thermostat')&&(item.ui_item_id === element_id)) {
        let step
        if (JSON.parse(item.add_data).hasOwnProperty('change_step')) {
          step = JSON.parse(item.add_data).change_step
          if (!step) step = 1;
        }
        item.params.map(param =>{
          if(param.param_sub_id === 'comf_temp') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  if(state.param_value){
                    par_new_value = parseFloat((parseFloat(state.param_value) - step).toFixed(1))
                    if(par_new_value<=0) par_new_value = 0;
                    state.param_value = par_new_value.toString()
                  }
                }
                return state
              })
            )
          }
        })
      }
    })
    printLog('Thermostat param: ', par_id, '; new_value: ' , par_new_value)
    if((par_new_value>=0)&&(par_new_value<100)) api.sendSetParam(par_id, par_new_value.toString())
  }

  // Update thermostat param mode
  function clickMode(element_id, mode){
    printLog('MODE element_id',element_id, 'mode', mode)
    let par_id = 0
    let par_new_value = null
    config.ui_items.map(item =>{
      if((item.ui_item_type === 'thermostat')&&(item.ui_item_id === element_id)) {
        item.params.map(param =>{
          if(param.param_sub_id === 'mode') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  par_new_value = parseInt(mode)
                  state.param_value = par_new_value.toString()
                }
                return state
              })
            )
          }
        })
      }
    })
    printLog('param: ', par_id, '; new_value: ' , par_new_value)
    api.sendSetParam(par_id, par_new_value.toString())
  }

  // Menu room element click
  function roomClick(room_id) {
    setElfield({field_type: 'room', field_id: room_id, ui_cfg: config} )
    setUiState('Normal')
  }
  // Menu category element click
  function categoryClick(category_id) {
    setElfield({field_type: 'category', field_id: category_id, ui_cfg: config} )
    setUiState('Normal')
  }

  // Logic of setting new slider value
  function SetNewValue(par_id, value, prew_value){
    printLog('par_id, value, prew_value',par_id, value, prew_value)
    
    if ((sys_time+SendTimeout < Date.now())){ 
      sys_time = Date.now()
      api.sendSetParam(par_id, value.toString())
      if (value != 0) dest_params[par_id-1] = {param_id : par_id, param_value : value}
    }
    else if ((prew_value+ValueDelta <= value) || (prew_value-ValueDelta >= value)) {
      api.sendSetParam(par_id, value.toString())
      if (value != 0) dest_params[par_id-1] = {param_id : par_id, param_value : value}
    }

  }

  // Set new slider color
  function newColor(element_id, color){
    printLog(element_id, color)
    let par_id
    let prew_color
    config.ui_items.map(item =>{
      if(((item.ui_item_type === 'rgb')||(item.ui_item_type === 'rgbw')||(item.ui_item_type === 'warm_cold'))&&(item.ui_item_id === element_id)){
        item.params.map(param =>{
          if(param.param_sub_id === 'hue') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  prew_color = parseInt(state.param_value)
                  state.param_value = color.toString()
                }
                return state
              })
            )
          }
        })
        SetNewValue(par_id, color, prew_color)
      }
    })
  }

  function newColorUp(element_id, color){
    printLog(element_id, color)
    let par_id
    config.ui_items.map(item =>{
      if(((item.ui_item_type === 'rgb')||(item.ui_item_type === 'rgbw')||(item.ui_item_type === 'warm_cold'))&&(item.ui_item_id === element_id)){
        item.params.map(param =>{
          if(param.param_sub_id === 'hue') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  state.param_value = color.toString()
                  api.sendSetParam(par_id, color.toString())
                }
                return state
              })
            )
          }
        })
      }
    })
  }

  // Set new slider brightness
  function newBright(element_id, value){
    let par_id
    let prew_value
    config.ui_items.map(item =>{
      if(((item.ui_item_type === 'rgb')||(item.ui_item_type === 'rgbw')||(item.ui_item_type === 'dimmer')||(item.ui_item_type === 'warm_cold'))&&(item.ui_item_id === element_id)){
        item.params.map(param =>{
          if(param.param_sub_id === 'bright') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  prew_value = parseInt(state.param_value)
                  state.param_value = value.toString()
                }
                return state
              })
            )
          }
        })
        SetNewValue(par_id, value, prew_value)
      }
    })
  }

  function newBrightUp(element_id, value){
    let par_id
    config.ui_items.map(item =>{
      if(((item.ui_item_type === 'rgb')||(item.ui_item_type === 'rgbw')||(item.ui_item_type === 'dimmer')||(item.ui_item_type === 'warm_cold'))&&(item.ui_item_id === element_id)){
        item.params.map(param =>{
          if(param.param_sub_id === 'bright') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  state.param_value = value.toString()
                  if (value != 0) dest_params[par_id-1] = {param_id : par_id, param_value : value}
                  api.sendSetParam(par_id, value.toString())
                }
                return state
              })
            )
          }
        })
      }
    })
  }

  // Set new slider curtains
  function newTargetPos(element_id, value){
    let par_id
    let prew_value
    config.ui_items.map(item =>{
      if(((item.ui_item_type === 'curtains'))&&(item.ui_item_id === element_id)){
        item.params.map(param =>{
          if(param.param_sub_id === 'target_pos') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  prew_value = parseInt(state.param_value)
                  state.param_value = value.toString()
                }
                return state
              })
            )
          }
        })
        SetNewValue(par_id, value, prew_value)
      }
    })
  }

  function newTargetPosUp(element_id, value){
    let par_id
    config.ui_items.map(item =>{
      if(((item.ui_item_type === 'curtains'))&&(item.ui_item_id === element_id)){
        item.params.map(param =>{
          if(param.param_sub_id === 'target_pos') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  state.param_value = value.toString()
                  api.sendSetParam(par_id, value.toString())
                }
                return state
              })
            )
          }
        })
      }
    })
  }

  // Set new slider saruration
  function newSaturation(element_id, value){
    let par_id
    let prew_value
    config.ui_items.map(item =>{
      if(((item.ui_item_type === 'rgb')||(item.ui_item_type === 'rgbw'))&&(item.ui_item_id === element_id)){
        item.params.map(param =>{
          if(param.param_sub_id === 'saturation') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  prew_value = parseInt(state.param_value)
                  state.param_value = value.toString()
                }
                return state
              })
            )
          }
        })
        SetNewValue(par_id, value, prew_value)
      }
    })
  }

  function newSaturationUp(element_id, value){
    let par_id
    config.ui_items.map(item =>{
      if(((item.ui_item_type === 'rgb')||(item.ui_item_type === 'rgbw'))&&(item.ui_item_id === element_id)){
        item.params.map(param =>{
          if(param.param_sub_id === 'saturation') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  state.param_value = value.toString()
                  api.sendSetParam(par_id, value.toString())
                }
                return state
              })
            )
          }
        })
      }
    })
  }

  // Set new switch state
  function newSwState(element_id, value){
    let par_id
    value = value.toString()
    printLog('value',value)
    config.ui_items.map(item =>{
      if((item.ui_item_type === 'switch')&&(item.ui_item_id === element_id)){
        item.params.map(param =>{
          if(param.param_sub_id === 'state') {
            par_id = param.param_id
            setParams(
              params.map( state=>{
                if(parseInt(state.param_id) === par_id) {
                  state.param_value = value
                }
                return state
              })
            )
            api.sendSetParam(par_id, value)
          }
        })
      }
    })
  }

  // Add New user
  async function addNewUser(username, password){
    printLog('ADD: username, password', username, password)
    let pass_hash = await hash.hashPass(username, password)
    await api.sendAddUser(username, username, pass_hash)
    let new_users = await api.sendGetAllUsers()
    printLog('new_users',new_users)
    if ((new_users)&&(new_users.result)) {
      setUsers(new_users.users)
    }
    else getUsers()
  }

  // Delete user
  async function deleteUser(login){
    printLog('Delete: login', login)
    if((login)&&(login !== 'admin')&&(localStorage.getItem(CookieUserName))&&(login !== localStorage.getItem(CookieUserName))){
      await api.sendDeleteUser(login)
      let new_users = await api.sendGetAllUsers()
      printLog('new_users',new_users)
      if ((new_users)&&(new_users.result)) {
        setUsers(new_users.users)
      }
      else getUsers()
    }
    else pushWindow ('( ◡‿◡ *)  '+localization.localize(ui_language).admin_delete_msg)
  }

  async function lattLongUpd(new_latt, new_long){
    printLog('LL Receive', new_latt, new_long)
    weatherUpdate(new_latt, new_long)
    setLattLong([new_latt, new_long])
  }

  function UiMode(mode){
    setUiMode(mode)
    UiModeInit(mode)
    localStorage.setItem(CookieUiMode, mode)
  }

  function longTouch(ui_element_id) {
    printLog('Touch start ', ui_element_id)
    timer = setTimeout(()=>{
        boubleClickMethod(ui_element_id);
    }, touchduration);
  }
  function touchend() {
      if (timer) clearTimeout(timer);
      printLog('Touch END')
  }

  // CSS styles
  function UiModeInit(ui_mode){
    if(HvParams.windowHeight) css_var.style.setProperty('--viewheight', HvParams.windowHeight + 'px')
    css_var.style.setProperty('--overlay', 'url('+BackgroundOverlay+')')
    switch (ui_mode) {
      case 0: //Dark
      default:
        css_var.style.setProperty('--main_background', '#0e0e13f0')
        css_var.style.setProperty('--second_background', '#22282ce0')
        css_var.style.setProperty('--text_color', '#efefef')
        css_var.style.setProperty('--text_secondary_color', '#7A7574')
        css_var.style.setProperty('--add_color', '#FFB900')
        css_var.style.setProperty('--shadow_color', '#000000')
        css_var.style.setProperty('--switch_on_color', '#FFB900')
        css_var.style.setProperty('--switch_off_color', '#6f6f6f')
        css_var.style.setProperty('--element_background', '#30363ba1')
        css_var.style.setProperty('--element_text', '#fff')
        css_var.style.setProperty('--content_background', 'url('+BackgroundBlack+')')
        break;
      
      case 1: //White
        css_var.style.setProperty('--main_background', '#ffffff')
        css_var.style.setProperty('--second_background', '#fafafa')
        css_var.style.setProperty('--text_color', '#303030')
        css_var.style.setProperty('--text_secondary_color', '#8b9b9b')
        css_var.style.setProperty('--add_color', '#00dcb0')
        css_var.style.setProperty('--shadow_color', '#dddddd')
        css_var.style.setProperty('--switch_on_color', '#00dcb0')
        css_var.style.setProperty('--switch_off_color', '#b1bfbe')
        css_var.style.setProperty('--element_background', '#ffffffd9')
        css_var.style.setProperty('--element_text', '#141414')
        css_var.style.setProperty('--content_background', 'url('+BackgroundWhite+')')
        break;

      case 2: //Warm
        css_var.style.setProperty('--main_background', '#686460f0')
        css_var.style.setProperty('--second_background', '#897f7c')
        css_var.style.setProperty('--text_color', '#ffffff')
        css_var.style.setProperty('--text_secondary_color', '#f1f1f1')
        css_var.style.setProperty('--add_color', '#fff1e1')
        css_var.style.setProperty('--shadow_color', '#646464')
        css_var.style.setProperty('--switch_on_color', '#fff07d')
        css_var.style.setProperty('--switch_off_color', '#bfbebc')
        css_var.style.setProperty('--element_background', '#5b5b5b8c')
        css_var.style.setProperty('--element_text', '#fdfdfd')
        css_var.style.setProperty('--content_background', 'url('+BackgroundBrown+')')
        break;

      case 3: //Gray
        css_var.style.setProperty('--main_background', '#3d4351fa')
        css_var.style.setProperty('--second_background', '#3c404ede')
        css_var.style.setProperty('--text_color', '#fefefe')
        css_var.style.setProperty('--text_secondary_color', '#718a7b')
        css_var.style.setProperty('--add_color', '#99ffc1')
        css_var.style.setProperty('--shadow_color', '#18181e')
        css_var.style.setProperty('--switch_on_color', '#99ffc1')
        css_var.style.setProperty('--switch_off_color', '#647279')
        css_var.style.setProperty('--element_background', '#daddf43d')
        css_var.style.setProperty('--element_text', '#ffffff')
        //css_var.style.setProperty('--content_background', 'linear-gradient(65deg, var(--main_background) 25%, var(--second_background) 85%)')
        css_var.style.setProperty('--content_background', 'url('+BackgroundGray+')')
        break; 

      case 4: //Blue
        css_var.style.setProperty('--main_background', '#002a50f2')
        css_var.style.setProperty('--second_background', '#003566')
        css_var.style.setProperty('--text_color', '#eee')
        css_var.style.setProperty('--text_secondary_color', '#acb7c2')
        css_var.style.setProperty('--add_color', '#e5d977')
        css_var.style.setProperty('--shadow_color', '#082642')
        css_var.style.setProperty('--switch_on_color', '#e5d977')
        css_var.style.setProperty('--switch_off_color', '#042f62')
        css_var.style.setProperty('--element_background', '#012444')
        css_var.style.setProperty('--element_text', '#eee')
        css_var.style.setProperty('--content_background', 'linear-gradient(65deg, var(--main_background) 25%, var(--second_background) 85%)')
        break;

      case 5: //Green
        css_var.style.setProperty('--main_background', '#4a504df2')
        css_var.style.setProperty('--second_background', '#565f5a')
        css_var.style.setProperty('--text_color', '#f0f0f0')
        css_var.style.setProperty('--text_secondary_color', '#dddee0')
        css_var.style.setProperty('--add_color', '#22a86d')
        css_var.style.setProperty('--shadow_color', '#2b2a2d')
        css_var.style.setProperty('--switch_on_color', '#22a86d')
        css_var.style.setProperty('--switch_off_color', '#3f4c46')
        css_var.style.setProperty('--element_background', '#2e2f31')
        css_var.style.setProperty('--element_text', '#eee')
        css_var.style.setProperty('--content_background', 'linear-gradient(65deg, var(--main_background) 25%, var(--second_background) 85%)')
        break;

      case 6: //Sun
        css_var.style.setProperty('--main_background', '#ffb98bf2')
        css_var.style.setProperty('--second_background', '#ff667b')
        css_var.style.setProperty('--text_color', '#ffffff')
        css_var.style.setProperty('--text_secondary_color', '#fff5dc')
        css_var.style.setProperty('--add_color', '#ffffff')
        css_var.style.setProperty('--shadow_color', '#fe9452')
        css_var.style.setProperty('--switch_on_color', '#fe5276')
        css_var.style.setProperty('--switch_off_color', '#ffe3d3')
        css_var.style.setProperty('--element_background', '#ffffff')
        css_var.style.setProperty('--element_text', '#a64d4d')
        css_var.style.setProperty('--content_background', 'linear-gradient(65deg, var(--main_background) 25%, var(--second_background) 85%)')
        break;

      case 7: //Violet
        css_var.style.setProperty('--main_background', '#d091c5f2')
        css_var.style.setProperty('--second_background', '#aaa6d9')
        css_var.style.setProperty('--text_color', '#fff')
        css_var.style.setProperty('--text_secondary_color', '#dfdcef')
        css_var.style.setProperty('--add_color', '#fd5b84')
        css_var.style.setProperty('--shadow_color', '#bd78a7')
        css_var.style.setProperty('--switch_on_color', '#efecf3')
        css_var.style.setProperty('--switch_off_color', '#b384b9')
        css_var.style.setProperty('--element_background', '#a9aae1')
        css_var.style.setProperty('--element_text', '#eee')
        css_var.style.setProperty('--content_background', 'linear-gradient(65deg, var(--main_background) 25%, var(--second_background) 85%)')
        break;
    }
  }

  // Main UI state machine
  switch (ui_state) {
    case 'Start':
    case 'Loading':
      css_var.style.setProperty('--filter', '')

      if ((connection)&&(!auth)){
        let cookie_user = localStorage.getItem(CookieUserName)
        let cookie_pass = localStorage.getItem(CookieUserPass)
        let cookie_token = localStorage.getItem(CookieUserToken)
        let cookie_token_exp = localStorage.getItem(CookieUserTokenExp)
        if (cookie_user && cookie_token && (cookie_token_exp > sys_time + TOKEN_EXP_DELTA)) {
          authStart({login: cookie_user, istoken: true, token: cookie_token, new_token: false}) 
        }
        else if (cookie_user && cookie_pass) {
          authStart({login: cookie_user, password: cookie_pass, istoken: false, token: null, new_token: true})
        }
        else {
          if (ui_state !== 'Auth') setUiState('Auth')
        }
      }
      else if ((connection)&&(auth)&&(!upd_config)) setUiState('Normal')
      page_data = <div id="preloader">
          <div className="setloadtxt" id="load_text">{load_text}</div>
          <div id="loader"></div>
          <ModalWindow msg={modal_msg} closeModal={closeModal} />
        </div>
      break;
    
    case 'SoftwareUpdate':
      css_var.style.setProperty('--filter', '')

      page_data = (<div id="preloader">
        <ModalWindow msg={modal_msg} closeModal={closeModal} />
        <div className="setloadtxt" id="load_text"> {load_text} </div>
        <ProgressLine
        id="load_progress"
        visualParts={[
          {
            percentage: percent+"%",
            color: "var(--text_color)"
          }
        ]}
      />
        <div id="loader"></div>
        </div>)
      break;

    case 'Auth':
      css_var.style.setProperty('--filter', '')

      page_data = ( <div>
        <AuthPage authStart={authStart} ui_language={ui_language} pushWindow={pushWindow}/>
        <ModalWindow msg={modal_msg} closeModal={closeModal} />
        </div>) 
      break;
    
    case 'Normal':
      if (!is_new_software) newSoftwareCheck()
      css_var.style.setProperty('--filter', '')

      if (screen_type == 'horizontal') {
        page_data = <div onTouchEndCapture={touchend()}  onPointerDownCapture={(e)=>posUpd(e)}>
          <ModalWindow msg={modal_msg} closeModal={closeModal} />
          <div className="background"></div>
          <div className='menu'>
            <Menu menu={menu} elfield={elfield} room_click={roomClick} category_click={categoryClick} addMenu={addMenu} cur_time={cur_time} ui_language={ui_language} weath_data={weath_data}/>
          </div>
          <div className='content'>
            <ElementsField elfield={elfield} key={menu} params={params} click_element={clickMethod} boubleClick={boubleClickMethod} clickPlus={clickPlus} clickMinus={clickMinus} longTouch={longTouch} touchend={touchend} ui_language={ui_language}/>
          </div>
        </div>
      }
      else {
        page_data = <Swipeable onSwipedRight={()=>setUiState('Menu')} onTouchEndCapture = {touchend()}>
          <ModalWindow msg={modal_msg} closeModal={closeModal} />
          <div className="background"></div>
          <div className='menu_button_vertical' onClick={()=>setUiState('Menu')}><IconMenu/></div>
          <div className='content_vertical'>
            <ElementsFieldVertical elfield={elfield} key={menu} params={params} click_element={clickMethod} boubleClick={boubleClickMethod} clickPlus={clickPlus} clickMinus={clickMinus} longTouch={longTouch} touchend={touchend} ui_language={ui_language}/>
          </div>
          </Swipeable>
      }
      break;

    case 'Element':
      css_var.style.setProperty('--filter', 'blur(2px)')

      if (screen_type == 'horizontal') {
        page_data = <Swipeable onSwipedRight={()=>toNormalState()} onTouchEndCapture = {touchend()}>
          <ModalWindow msg={modal_msg} closeModal={closeModal} />
          <div className="background"></div>
          <div className='menu'>
            <Menu menu={menu} elfield={elfield} room_click={roomClick} category_click={categoryClick} addMenu={addMenu} cur_time={cur_time} ui_language={ui_language} weath_data={weath_data}/>
          </div>
          <div className='content'>
            <ElementsField elfield={elfield} key={menu} params={params} click_element={clickMethod} boubleClick={boubleClickMethod} clickPlus={clickPlus} clickMinus={clickMinus} ui_language={ui_language}/>
          </div>
            <ElementPage element_id={global_element_id} key={global_element_id} config={config} ui_language={ui_language} params={params} newColor={newColor} newColorUp={newColorUp} newBright={newBright} newBrightUp={newBrightUp} newTargetPos={newTargetPos} newTargetPosUp={newTargetPosUp} newSaturation={newSaturation} newSaturationUp={newSaturationUp} newSwState={newSwState} clickPlus={clickPlus} clickMinus={clickMinus} toNormalState={toNormalState} toChartState={toChartState} clickMode={clickMode}/>
        </Swipeable>
      }
      else {
        page_data = <Swipeable onSwipedRight={()=>toNormalState()} onTouchEndCapture = {touchend()}>
          <ModalWindow msg={modal_msg} closeModal={closeModal} />
          <div className="background"></div>
          
          <div className='content_vertical'>
            <ElementsFieldVertical elfield={elfield} key={menu} params={params} click_element={clickMethod} boubleClick={boubleClickMethod} clickPlus={clickPlus} clickMinus={clickMinus} ui_language={ui_language}/>
          </div>
            <ElementPageVertical element_id={global_element_id} key={global_element_id} config={config} ui_language={ui_language} params={params} newColor={newColor} newBright={newBright} newSaturation={newSaturation} newColorUp={newColorUp} newBrightUp={newBrightUp} newSaturationUp={newSaturationUp} newTargetPos={newTargetPos} newTargetPosUp={newTargetPosUp} newSwState={newSwState} clickPlus={clickPlus} clickMinus={clickMinus} toNormalState={toNormalState} toChartState={toChartState} clickMode={clickMode}/>
        </Swipeable>
      }
      break;

      case 'ElementAdditional':
        css_var.style.setProperty('--filter', 'blur(2px)')
  
        if (screen_type == 'horizontal') {
          page_data = <Swipeable onSwipedRight={()=>toNormalState()} onTouchEndCapture = {touchend()}>
            <ModalWindow msg={modal_msg} closeModal={closeModal} />
            <div className="background"></div>
            <div className='menu'>
              <Menu menu={menu} elfield={elfield} room_click={roomClick} category_click={categoryClick} addMenu={addMenu} cur_time={cur_time} ui_language={ui_language} weath_data={weath_data}/>
            </div>
            <div className='content'>
              <ElementsField elfield={elfield} key={menu} params={params} click_element={clickMethod} boubleClick={boubleClickMethod} clickPlus={clickPlus} clickMinus={clickMinus} ui_language={ui_language}/>
            </div>
            <ElementAdditionalPage element_id={global_element_id} key={global_element_id} config={config} chart_data={chart_data} ui_language={ui_language} params={params} newColor={newColor} newColorUp={newColorUp} newBright={newBright} newBrightUp={newBrightUp} newTargetPos={newTargetPos} newTargetPosUp={newTargetPosUp} newSaturation={newSaturation} newSaturationUp={newSaturationUp} newSwState={newSwState} clickPlus={clickPlus} clickMinus={clickMinus} toNormalState={toNormalState} toChartState={toChartState} clickMode={clickMode}/>
          </Swipeable>
        }
        else {
          page_data = <Swipeable onSwipedRight={()=>toNormalState()} onTouchEndCapture = {touchend()}>
            <ModalWindow msg={modal_msg} closeModal={closeModal} />
            <div className="background"></div>
            
            <div className='content_vertical'>
              <ElementsFieldVertical elfield={elfield} key={menu} params={params} click_element={clickMethod} boubleClick={boubleClickMethod} clickPlus={clickPlus} clickMinus={clickMinus} ui_language={ui_language}/>
            </div>
            <ElementAdditionalPageVertical element_id={global_element_id} key={global_element_id} config={config} chart_data={chart_data} ui_language={ui_language} params={params} newColor={newColor} newColorUp={newColorUp} newBright={newBright} newBrightUp={newBrightUp} newTargetPos={newTargetPos} newTargetPosUp={newTargetPosUp} newSaturation={newSaturation} newSaturationUp={newSaturationUp} newSwState={newSwState} clickPlus={clickPlus} clickMinus={clickMinus} toNormalState={toNormalState} toChartState={toChartState} clickMode={clickMode}/>
          </Swipeable>
        }
        break;

    case 'Menu':
      css_var.style.setProperty('--filter', 'blur(2px)')

      if (screen_type == 'vertical'){
        page_data = <Swipeable onSwipedLeft={() => setUiState('Normal')} onTouchEndCapture = {touchend()}>
          <ModalWindow msg={modal_msg} closeModal={closeModal} />
          <div className='menu_vertical'>
            <MenuVertical weath_data={weath_data} menu={menu} elfield={elfield} room_click_vertical={roomClick} category_click_vertical={categoryClick} toNormalState={toNormalState} addMenu={addMenu} ui_language={ui_language}/>
          </div>
          <div className="background"></div>
          <div className='content_vertical'>
            <ElementsFieldVertical elfield={elfield} params={params} click_element={clickMethod} boubleClick={boubleClickMethod} clickPlus={clickPlus} clickMinus={clickMinus} ui_language={ui_language}/>
          </div>
          <div className="menuVerticalEmpty" onClick={() => setUiState('Normal')}></div>
        </Swipeable>
      }
      else setUiState('Normal')
      break;

    case 'AddMenu':  
      css_var.style.setProperty('--filter', 'blur(2px)')

      if (!is_new_software) newFtpSoftwareCheck()
      if (screen_type === 'horizontal') {
        page_data = <div>
          <ModalWindow msg={modal_msg} closeModal={closeModal} />
          <div className="background"></div>
          <div className='menu'>
            <Menu menu={menu} elfield={elfield} room_click={roomClick} category_click={categoryClick} addMenu={addMenu} ui_language={ui_language} weath_data={weath_data}/>
          </div>

          <div className='content'>
            <ElementsField elfield={elfield} key={menu} params={params} click_element={clickMethod} boubleClick={boubleClickMethod} clickPlus={clickPlus} clickMinus={clickMinus} ui_language={ui_language}/>
          </div>
            <AddMenu toNormalState={toNormalState} logOut={logOut} ui_version={ui_version} username={localStorage.getItem(CookieUserName)} UiMode={UiMode} ui_mode={ui_mode} ui_language={ui_language} updLanguage={updLanguage} users={users} addNewUser={addNewUser} deleteUser={deleteUser} is_new_software={is_new_software} clickUpdateButton={clickUpdateButton} latt={latt_long[0]} long={latt_long[1]} lattLongUpd={lattLongUpd} pushWindow={pushWindow}/>
        </div>
      }
      else {
        page_data = <div>
          <ModalWindow msg={modal_msg} closeModal={closeModal} />
          <div className="background"></div>
          <div className='menu_vertical'>
            <MenuVertical weath_data={weath_data} menu={menu} elfield={elfield} room_click_vertical={roomClick} category_click_vertical={categoryClick} toNormalState={toNormalState} addMenu={addMenu} ui_language={ui_language}/>
          </div>
          <div className='content_vertical'>
            <ElementsFieldVertical elfield={elfield} key={menu} params={params} click_element={clickMethod} boubleClick={boubleClickMethod} clickPlus={clickPlus} clickMinus={clickMinus} ui_language={ui_language}/>
          </div>
            <AddMenuVertical toNormalState={toNormalState} logOut={logOut} ui_version={ui_version} username={localStorage.getItem(CookieUserName)} UiMode={UiMode} ui_mode={ui_mode} ui_language={ui_language} updLanguage={updLanguage} users={users} addNewUser={addNewUser} deleteUser={deleteUser} is_new_software={is_new_software} clickUpdateButton={clickUpdateButton} latt={latt_long[0]} long={latt_long[1]} lattLongUpd={lattLongUpd} pushWindow={pushWindow}/>
        </div>
      }
      break;

    case 'Idle':
      css_var.style.setProperty('--filter', '')
      if (screen_type === 'horizontal') {
        page_data = <Idle cur_time={cur_time} />
      }
      else {
        page_data = <IdleVertical cur_time={cur_time} />
      }
      break;
  }

    printLog('return')
    return (page_data)
}

export default App;
